import React from 'react';
import moment from 'moment';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import ListResource from './ListResource.jsx';

const api = '/api/quiz/levels';

const ListLevels = () => {
  const [res, req] = useHttpStatus();

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { score: 1 },
        cols: [
          //{ key: 'title.en', sortable: true, children: 'Title' },
          { key: 'title.zhhk', sortable: true, children: 'Title' },
          {
            key: 'score',
            sortable: true,
          },
        ],
      }}
    >
    </ListResource>
  );
};

export default ListLevels;
